import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Zoom from "@arcgis/core/widgets/Zoom";
import {
    rasterLayer,
    haltestellenLayer,
    statisticRasterLayer,
    infrastrukturQualitaetLayer,
    poiSchoolLayer,
    poiLebensmittelLayer,
    mobilfunkStundengruppenLayer5Uhr,
    mobilfunkStundengruppenLayer6Uhr,
    mobilfunkStundengruppenLayer7Uhr,
    mobilfunkStundengruppenLayer8Uhr, einwohnerImUmkreis1000
} from "./feature-layers";
import WMTSLayer from "@arcgis/core/layers/WMTSLayer";
import GroupLayer from "@arcgis/core/layers/GroupLayer";
import Basemap from "@arcgis/core/Basemap";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
import Attribution from "@arcgis/core/widgets/Attribution.js";
import LayerList from "@arcgis/core/widgets/LayerList";
import Expand from "@arcgis/core/widgets/Expand";

const POIGroupLayer = new GroupLayer({
    title: "POIs Land Salzburg",
    visible: false,
    layers: [poiLebensmittelLayer, poiSchoolLayer],
})

const mobilfunkStundenGroupLayer = new GroupLayer({
    title: "Pendler - räumlich/zeitliche Verteilung (Mobilfunk- + Statistikdaten)",
    visible: false,
    layers:[mobilfunkStundengruppenLayer8Uhr, mobilfunkStundengruppenLayer7Uhr,
        mobilfunkStundengruppenLayer6Uhr, mobilfunkStundengruppenLayer5Uhr]
})

const basemapATGrayLayer = new WMTSLayer({
    url: "https://mapsneu.wien.gv.at/basemapneu/1.0.0/WMTSCapabilities.xml",
    activeLayer:{
        id:"bmapgrau",
    },
    copyright: "Grundkarte: basemap.at",
    listMode: "hide",
})

const basemapATOrthofoto = new WMTSLayer(
    {
        url: "https://mapsneu.wien.gv.at/basemapneu/1.0.0/WMTSCapabilities.xml",
        activeLayer:{
            id:"bmaporthofoto30cm",
        },
        copyright: "Grundkarte: basemap.at",
        listMode: "hide",
    }
)

const esriLightGrayCanvas = new VectorTileLayer(
    {
        portalItem: {
            id: "291da5eab3a0412593b66d384379f89f"
        }
    }
)

const basemapGray = new Basemap({
    baseLayers: [esriLightGrayCanvas, basemapATGrayLayer],
    // thumbnailUrl:"https://mapsneu.wien.gv.at/basemap/bmapgrau/normal/google3857/15/11414/17570.png",
    thumbnailUrl:"gray-vector-thumbnail-17570.png",
    title: "Grau",
    id: "basemapGray",
})

const basemapOrthofoto = new Basemap({
    baseLayers: [basemapATOrthofoto],
    // thumbnailUrl: "https://mapsneu.wien.gv.at/basemap/bmaporthofoto30cm/normal/google3857/15/11414/17570.jpeg",
    thumbnailUrl: "orthofoto-thumbnail-17570.jpeg",
    title: "Orthofoto",
    id: "basemapGray",
})

export function createMapView(mapContainer){
    if (mapContainer){
        const map = new Map({
            basemap: basemapGray,
            layers: [
                mobilfunkStundenGroupLayer,
                infrastrukturQualitaetLayer,
                statisticRasterLayer,
                einwohnerImUmkreis1000,
                POIGroupLayer,
                rasterLayer,
                haltestellenLayer,
            ],
        });

        const view = new MapView({
            container: mapContainer, // the current value of the mapRef
            map: map,
            zoom: 14,
            center: [13.051706,47.811949],
        });

        view.popup = {
            dockEnabled: true,
            dockOptions: {
                position: "bottom-left",
                breakpoint: false
            }
        };

        const zoom = new Zoom({
            view: view
        });

        let basemapToggle = new BasemapToggle({
            view: view,  // The view that provides access to the map's "streets-vector" basemap
            nextBasemap: basemapOrthofoto,
            visibleElements: {
                title: true
            },
        });

        const attribution = new Attribution({
            view: view
        })

        const layerList = new LayerList({
            view: view,
            listItemCreatedFunction: (event) => {
                const item = event.item;
                // avoid duplicated legend, please adjust the value if layer changes.
                if (item.layer.title !== "Statistik" &&
                    item.layer.title !== "Haltestellen" &&
                    item.layer.title !== "POIs Land Salzburg" &&
                    item.layer.title !== "Pendler - räumlich/zeitliche Verteilung (Mobilfunk- + Statistikdaten)"
                ) {
                    item.panel = {
                        content: "legend",
                        open: true,
                    };
                }
            }
        })

        const layerListExpand = new Expand({
            view: view,
            content: layerList,
            expandTooltip: "Layer-Liste",
            expanded: true,
        })

        view.ui.components = []; // remove default components

        view.ui.add([
            {
                component: zoom,
                position: "bottom-right",
            },
            {
                component: basemapToggle,
                position: "bottom-left",
            }, {
                component: attribution,
            },
            {
                component: layerListExpand,
                position: "top-right",
            }
        ]);
        return view;
    }
}
